/**
 * Theme name for the defaults shared by every `Form*` field. The v2 theme turns
 * `labelAbove` on here; fields read it with `useThemeProps`.
 */
export const FORM_FIELD_THEME_NAME = 'OvFormField';
export const FORM_FIELD_LABEL_THEME_NAME = 'OvFormFieldLabel';
/** Line height of a v2 field label; a layout that reserves room for the label reads it from here. */
export const V2_FIELD_LABEL_LINE_HEIGHT = '1rem';
/** Gap under a v2 field label, in `theme.spacing` units. */
export const V2_FIELD_LABEL_GAP = 0.875;
export const RICH_TEXT_FIELD_BOX_THEME_NAME = 'OvRichTextFieldBox';
export const FORM_TOGGLE_GROUP_THEME_NAME = 'OvFormToggleGroup';
/** Kept apart from `OvFormField`: every field spreads unknown props onto its DOM root. */
export const FORM_CHIP_GROUP_THEME_NAME = 'OvFormChipGroup';
/** The label-and-switch row of `FormSwitch`. */
export const FORM_SWITCH_LABEL_THEME_NAME = 'OvFormSwitchLabel';
